import { useMemo } from 'react';
import { useQuery } from 'shared-ui';

import { fetchUsers } from 'api/users/users';
import { QueryKeyEnum } from 'core/global.enum';
import { fetchMailAccount } from 'api/mailAccount/mailAccount';

import { EmailSelectionModal } from './EmailSelectionModal';
import { EmailSelectionModalContainerProps } from './EmailSelectionModal.types';

export const EmailSelectionModalContainer = (props: EmailSelectionModalContainerProps) => {
  const { data: usersResponse, isLoading: isLoadingUsers } = useQuery([QueryKeyEnum.USERS], fetchUsers, {
    args: {
      limit: 1000,
      offset: 0,
    },
  });

  const { data: mailAccountResponse, isLoading: isLoadingMailAccount } = useQuery(
    [QueryKeyEnum.MAIL_ACCOUNT],
    fetchMailAccount,
  );

  const users = useMemo(() => {
    if (usersResponse?.data) {
      return (
        usersResponse.data
          .filter((user) => user.email && user.status === 'AKTYWNY')
          .map((user) => ({ value: user.email as string, label: `${user.imie} ${user.nazwisko}` })) || []
      );
    }

    return [];
  }, [usersResponse]);

  const isSmtpConfigured = useMemo(() => {
    return !!mailAccountResponse?.address;
  }, [mailAccountResponse]);

  return (
    <EmailSelectionModal
      {...props}
      availableUsers={users}
      isLoading={props.isLoading || isLoadingUsers || isLoadingMailAccount}
      isSmtpConfigured={isSmtpConfigured}
    />
  );
};
